// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-home-L":"L_power-ocean-home-L__077ED"};